import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { normalizeMatchingInternalProducts } from './normalizeMatchingInternalProducts';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

const MIN_QUERY_LENGTH = 2;

/**
 * Recherche des produits internes par référence ou titre (10 premiers résultats).
 * Renvoie pour chaque produit : reference, title, stockQuantity, color, packaging.
 */
function useSearchInternalProducts(query) {
  const trimmedQuery = (query || '').trim();
  const shouldFetch = trimmedQuery.length >= MIN_QUERY_LENGTH;

  const { data, error, isLoading } = useSWR(
    shouldFetch
      ? `/savdraft/matchingInternalProducts/${encodeURIComponent(trimmedQuery)}`
      : null,
    (url) => fetcher(url),
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
    }
  );

  return {
    products: normalizeMatchingInternalProducts(data),
    isLoading: shouldFetch && isLoading,
    error,
  };
}

export default useSearchInternalProducts;
